(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const px = (el, name) => parseFloat(getComputedStyle(el).getPropertyValue(name)) || 0;

    class MmxInstagramFeed {
      constructor(root) {
        this.root = root;
        this.viewport = root.querySelector('[data-mmx-ig-viewport]');
        this.track = root.querySelector('[data-mmx-ig-track]');
        this.cards = [...root.querySelectorAll('[data-mmx-ig-card]')];
        this.count = Number(root.dataset.count) || 0;
        this.middleStart = (Number(root.dataset.middle) || 0) * this.count;
        this.interval = Number(root.dataset.interval) || 3000;
        this.autoplay = root.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.viewport || !this.track || !this.count) return;

        // Figma centres the 3rd image, with two on its left.
        this.index = this.middleStart + Math.min(2, this.count - 1);
        this.render(false);

        this.track.addEventListener('transitionend', (event) => {
          if (event.target === this.track && event.propertyName === 'transform') this.normalize();
        });
        this.bindPointer();
        this.bindAutoplay();

        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => this.render(false), 120);
        });
      }

      /* Position so the active card's centre sits at the viewport centre, using the final
         (post-transition) sizes so widths and offset animate together. */
      render(animate) {
        const w = px(this.root, '--mmx-ig-w');
        const activeW = px(this.root, '--mmx-ig-active-w');
        const gap = px(this.root, '--mmx-ig-gap');
        const offset = this.viewport.clientWidth / 2 - (this.index * (w + gap) + activeW / 2);

        this.track.classList.toggle('is-animating', animate);
        this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
        this.cards.forEach((card, i) => card.classList.toggle('is-active', i === this.index));
        // Commit un-animated jumps before any following animated move starts from them.
        if (!animate) void this.track.offsetWidth;
      }

      /* After an animated move, jump back into the middle copy without animation. */
      normalize() {
        const end = this.middleStart + this.count;
        if (this.index >= this.middleStart && this.index < end) return;
        this.index = this.middleStart + (((this.index - this.middleStart) % this.count) + this.count) % this.count;
        this.render(false);
      }

      /* Step relative to the current card; re-base first in case a transition was interrupted. */
      move(step) {
        this.normalize();
        this.index += step;
        this.render(true);
      }

      /* Centre a specific rendered card (e.g. a clicked side card). */
      goToCard(index) {
        if (index === this.index) return;
        this.index = index;
        this.render(true);
      }

      next() { this.move(1); }
      prev() { this.move(-1); }

      bindPointer() {
        let startX = 0;
        let dx = 0;
        let dragging = false;
        let moved = false;

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          dragging = true;
          moved = false;
          startX = event.clientX;
          dx = 0;
        });

        window.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          dx = event.clientX - startX;
          if (Math.abs(dx) > 8) moved = true;
        });

        window.addEventListener('pointerup', () => {
          if (!dragging) return;
          dragging = false;
          if (Math.abs(dx) > 40) {
            dx < 0 ? this.next() : this.prev();
            this.restartAutoplay();
          }
        });

        // Clicking a side card brings it to the centre; only the centred card follows its link.
        this.viewport.addEventListener('click', (event) => {
          const card = event.target.closest('[data-mmx-ig-card]');
          if (moved) {
            event.preventDefault();
            moved = false;
            return;
          }
          if (!card) return;
          const i = this.cards.indexOf(card);
          if (i !== this.index) {
            event.preventDefault();
            this.goToCard(i);
            this.restartAutoplay();
          }
        });

        // The browser took over the gesture (e.g. vertical page scroll): drop the drag.
        window.addEventListener('pointercancel', () => {
          dragging = false;
          moved = false;
        });

        this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
      }

      bindAutoplay() {
        if (!this.autoplay) return;
        const pause = () => this.stopAutoplay();
        const resume = () => this.startAutoplay();
        this.root.addEventListener('mouseenter', pause);
        this.root.addEventListener('mouseleave', resume);
        this.root.addEventListener('focusin', pause);
        this.root.addEventListener('focusout', resume);
        document.addEventListener('visibilitychange', () => (document.hidden ? pause() : resume()));
        this.startAutoplay();
      }

      startAutoplay() {
        if (!this.autoplay) return;
        this.stopAutoplay();
        this.timer = setInterval(() => this.next(), this.interval);
      }

      stopAutoplay() {
        clearInterval(this.timer);
      }

      restartAutoplay() {
        if (this.autoplay && !this.root.matches(':hover')) this.startAutoplay();
      }
    }

    const init = () => {
      document.querySelectorAll('[data-mmx-ig]').forEach((root) => {
        if (root.mmxIg) return;
        root.mmxIg = new MmxInstagramFeed(root);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-pdp-faqs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DURATION = 300;

    const animate = (item, open) => {
      const wrap = item.querySelector('.mmx-pdp-faqs__answer-wrap');
      if (!wrap || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        item.open = open;
        return;
      }
      clearTimeout(item.mmxTimer);
      if (open) item.open = true;
      item.dataset.mmxState = open ? 'opening' : 'closing';
      const from = open ? 0 : wrap.offsetHeight;
      const to = open ? wrap.scrollHeight : 0;
      wrap.style.height = `${from}px`;
      wrap.offsetHeight;
      wrap.style.transition = `height ${DURATION}ms ease`;
      wrap.style.height = `${to}px`;
      // Finish on a timer rather than `transitionend`, which Chrome doesn't reliably fire inside <details>.
      item.mmxTimer = setTimeout(() => {
        if (!open) item.open = false;
        delete item.dataset.mmxState;
        wrap.style.height = '';
        wrap.style.transition = '';
      }, DURATION + 20);
    };

    const isOpen = (item) => item.open && item.dataset.mmxState !== 'closing';

    const init = () => {
      document.querySelectorAll('[data-mmx-pf-list]').forEach((list) => {
        if (list.dataset.mmxInit) return;
        list.dataset.mmxInit = 'true';
        const single = list.dataset.singleOpen === 'true';
        const items = [...list.querySelectorAll('.mmx-pdp-faqs__item')];

        items.forEach((item) => {
          item.querySelector('.mmx-pdp-faqs__summary')?.addEventListener('click', (event) => {
            event.preventDefault();
            if (isOpen(item)) {
              animate(item, false);
              return;
            }
            if (single) items.forEach((other) => other !== item && isOpen(other) && animate(other, false));
            animate(item, true);
          });
        });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const emitCartUpdate = (sectionId, payload) => {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: payload,
            sourceId: sectionId,
            data: {
              source: 'product-form-component',
              itemCount: 1,
              productId: String(payload?.id || ''),
            },
          },
        })
      );
    };

    const bindGallery = (section) => {
      const mediaItems = section.querySelectorAll('[data-media-id]');
      const triggers = section.querySelectorAll('[data-media-trigger]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const activateMedia = (mediaId) => {
        if (!mediaId) return;
        let activeItem;
        mediaItems.forEach((item) => {
          const isActive = item.getAttribute('data-media-id') === mediaId;
          if (isActive && !item.classList.contains('is-active')) activeItem = item;
          item.classList.toggle('is-active', isActive);
        });
        // Crossfade into the newly selected image; the frame keeps a fixed height.
        if (activeItem && !reduceMotion.matches) {
          activeItem.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
        }
        triggers.forEach((trigger) => {
          const isActive = trigger.getAttribute('data-media-trigger') === mediaId;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        syncThumbs();
      };

      // Thumbnail arrows step through the images; the strip scrolls to keep the active thumbnail in view.
      const thumbList = section.querySelector('.mmx-product-main__thumbs');
      const arrows = section.querySelectorAll('[data-mmx-thumbs-arrow]');
      const activeIndex = () => [...triggers].findIndex((trigger) => trigger.classList.contains('is-active'));

      function syncThumbs() {
        if (!arrows.length) return;
        const index = activeIndex();
        arrows.forEach((arrow) => {
          const target = index + Number(arrow.dataset.mmxThumbsArrow);
          arrow.disabled = target < 0 || target >= triggers.length;
        });

        const thumb = triggers[index];
        if (!thumbList || !thumb || thumbList.scrollWidth <= thumbList.clientWidth) return;
        const left = thumb.offsetLeft;
        const right = left + thumb.offsetWidth;
        if (left < thumbList.scrollLeft || right > thumbList.scrollLeft + thumbList.clientWidth) {
          thumbList.scrollTo({
            left: Math.max(0, left - (thumbList.clientWidth - thumb.offsetWidth) / 2),
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
          });
        }
      }

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const next = triggers[activeIndex() + Number(arrow.dataset.mmxThumbsArrow)];
          if (next) activateMedia(next.getAttribute('data-media-trigger'));
        });
      });

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => activateMedia(trigger.getAttribute('data-media-trigger')));
      });
      syncThumbs();

      return activateMedia;
    };

    // Pushes a newly selected variant into the form, buy button, prices and gallery.
    const applyVariant = (section, activateMedia, { id, soldOut, price, subPrice, mediaId }) => {
      const idInput = section.querySelector('input[ref="variantId"]');
      const addToCartButton = section.querySelector('button.mmx-product-main__add-cart');
      const addToCartContainer = section.querySelector('add-to-cart-component');
      const subPriceEl = section.querySelector('[data-mmx-sub-price]');
      const oneTimePriceEl = section.querySelector('[data-mmx-onetime-price]');
      const atcPriceEl = section.querySelector('[data-mmx-atc-price]');

      if (idInput && id) idInput.value = id;

      if (addToCartButton) addToCartButton.disabled = soldOut;
      if (addToCartContainer) {
        if (soldOut) addToCartContainer.setAttribute('data-sold-out', 'true');
        else addToCartContainer.removeAttribute('data-sold-out');
      }

      if (subPriceEl && subPrice) subPriceEl.textContent = subPrice;
      if (oneTimePriceEl && price) oneTimePriceEl.textContent = price;
      if (atcPriceEl) {
        const mode = section.querySelector('input[data-mmx-mode]:checked')?.value || atcPriceEl.dataset.mode;
        const atcPrice = mode === 'subscribe' ? subPrice : price;
        if (atcPrice) atcPriceEl.textContent = atcPrice;
      }

      if (mediaId) activateMedia(mediaId);
    };

    const bindVariants = (section, activateMedia) => {
      const inputs = section.querySelectorAll(
        '.mmx-product-main__variant-pill input[type="radio"]:not([data-mmx-option-value])'
      );

      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;

          inputs.forEach((item) => {
            item.closest('.mmx-product-main__variant-pill')?.classList.toggle('is-active', item.checked);
          });

          applyVariant(section, activateMedia, {
            id: input.dataset.variantId,
            soldOut: input.dataset.soldOut === 'true',
            price: input.dataset.price,
            subPrice: input.dataset.subPrice,
            mediaId: input.dataset.variantMediaId,
          });
        });
      });
    };

    // Option-based picker (e.g. Color + Size): resolves the variant from one selected value per option.
    const bindMerchVariants = (section, activateMedia) => {
      const root = section.querySelector('[data-mmx-merch]');
      const json = root?.querySelector('[data-mmx-merch-variants]');
      if (!root || !json) return;

      let variants;
      try {
        variants = JSON.parse(json.textContent);
      } catch (_error) {
        return;
      }

      const fieldsets = [...root.querySelectorAll('[data-mmx-merch-option]')];
      const selectedValues = () =>
        fieldsets.map((fieldset) => fieldset.querySelector('input[data-mmx-merch-input]:checked')?.value);

      // Dims values that have no available variant when combined with the other current selections.
      const refreshAvailability = (selected) => {
        fieldsets.forEach((fieldset, optionIndex) => {
          fieldset.querySelectorAll('input[data-mmx-merch-input]').forEach((input) => {
            const available = variants.some(
              (variant) =>
                variant.available &&
                variant.options[optionIndex] === input.value &&
                variant.options.every((value, index) => index === optionIndex || value === selected[index])
            );
            input.parentElement.classList.toggle('is-disabled', !available);
          });
        });
      };

      root.addEventListener('change', (event) => {
        const input = event.target.closest('input[data-mmx-merch-input]');
        if (!input) return;

        const fieldset = input.closest('[data-mmx-merch-option]');
        fieldset.querySelectorAll('input[data-mmx-merch-input]').forEach((item) => {
          item.parentElement.classList.toggle('is-active', item.checked);
        });
        const valueLabel = fieldset.querySelector('[data-mmx-merch-value]');
        if (valueLabel) valueLabel.textContent = input.value;

        if (fieldset.hasAttribute('data-mmx-tint-option')) {
          const mediaMain = section.querySelector('.mmx-product-main__media-main');
          const tint = input.dataset.mmxTint?.trim();
          if (mediaMain && tint) {
            mediaMain.style.setProperty('--mmx-tint', tint);
            mediaMain.setAttribute('data-mmx-tint', '');
          } else if (mediaMain) {
            mediaMain.style.removeProperty('--mmx-tint');
            mediaMain.removeAttribute('data-mmx-tint');
          }
        }

        const selected = selectedValues();
        refreshAvailability(selected);

        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) {
          applyVariant(section, activateMedia, { soldOut: true });
          return;
        }

        applyVariant(section, activateMedia, {
          id: String(variant.id),
          soldOut: !variant.available,
          price: variant.price,
          subPrice: variant.subPrice,
          mediaId: variant.mediaId,
        });
      });

      refreshAvailability(selectedValues());
    };

    const bindFrequency = (section) => {
      const form = section.querySelector('.mmx-product-main__form');
      const planInput = section.querySelector('[data-mmx-selling-plan]');
      const modes = section.querySelectorAll('input[data-mmx-mode]');
      if (!form || !planInput || !modes.length) return;

      const currentMode = () => section.querySelector('input[data-mmx-mode]:checked')?.value;

      /* The Kaching Bundles app embed injects its own (hidden) subscription widget into this form. Kaching owns
         the final cart line: it writes its choice into `selling_plan` and its fetch interceptor rebuilds the
         line from its deal state. So our Frequency selector drives Kaching's hidden cards to keep both in step. */
      const kachingCards = () => {
        const cards = [...form.querySelectorAll('kaching-bundles-block .kaching-bundles__subscriptions__card')];
        if (cards.length < 2) return null;
        const onetime = cards.find((card) => /one[\s-]?time/i.test(card.textContent)) || cards[cards.length - 1];
        const subscribe = cards.find((card) => card !== onetime);
        return { onetime, subscribe };
      };

      // Kaching keeps an enabled `selling_plan` input only while its subscribe option is selected.
      const kachingMode = () => {
        const enabled = [...form.querySelectorAll('[name="selling_plan"]')].some((input) => !input.disabled && input.value);
        return enabled ? 'subscribe' : 'onetime';
      };

      const syncKaching = (force = false) => {
        const cards = kachingCards();
        const mode = currentMode();
        if (!cards || !mode) return;
        if (force || kachingMode() !== mode) cards[mode]?.click();
      };

      // Without Kaching, our hidden input decides the purchase type on its own.
      const applyOwnInput = () => {
        const mode = currentMode();
        if (!mode) return;
        if (!planInput.isConnected) form.prepend(planInput);
        planInput.value = planInput.dataset.planId;
        planInput.disabled = mode !== 'subscribe';
      };

      modes.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          modes.forEach((item) => {
            item.closest('.mmx-product-main__plan')?.classList.toggle('is-selected', item.checked);
          });
          const atcPrice = section.querySelector('[data-mmx-atc-price]');
          const modePrice = section.querySelector(
            input.value === 'subscribe' ? '[data-mmx-sub-price]' : '[data-mmx-onetime-price]'
          );
          if (atcPrice && modePrice) atcPrice.textContent = modePrice.textContent;
          // The trust row only applies to Subscribe & Save.
          section.querySelectorAll('[data-mmx-trust-row]').forEach((row) => {
            row.hidden = input.value !== 'subscribe';
          });
          if (kachingCards()) syncKaching(true);
          else applyOwnInput();
        });
      });

      // Kaching renders asynchronously and re-renders on variant changes; re-sync whenever it does.
      let syncTimer;
      new MutationObserver(() => {
        if (!kachingCards()) return;
        clearTimeout(syncTimer);
        syncTimer = setTimeout(() => syncKaching(), 150);
      }).observe(form, { childList: true, subtree: true });

      // Last check before the theme's product form reads the form (it dispatches `on:submit` from a capture
      // listener on `document`, so a capture listener on `window` runs first).
      window.addEventListener(
        'submit',
        (event) => {
          if (event.target !== form) return;
          if (kachingCards()) syncKaching();
          else applyOwnInput();
        },
        true
      );
    };

    // Flavor + Supply products: the pills pick the flavor, Subscribe & Save uses a fixed supply and
    // One-time Purchase uses the supply dropdown. The cart variant follows whichever option is selected.
    const bindSplitVariants = (section, activateMedia) => {
      const json = section.querySelector('[data-mmx-split-variants]');
      if (!json) return;

      let config;
      try {
        config = JSON.parse(json.textContent);
      } catch (_error) {
        return;
      }

      const { flavorIndex, supplyIndex, subscriptionSupply, variants } = config;
      const selected = [...config.current];
      const flavorInputs = section.querySelectorAll('input[data-mmx-option-value]');
      const supplySelect = section.querySelector('select[data-mmx-supply]');
      const onetimeInput = section.querySelector('input[data-mmx-mode][value="onetime"]');
      const subPriceEl = section.querySelector('[data-mmx-sub-price]');
      const oneTimePriceEl = section.querySelector('[data-mmx-onetime-price]');

      const currentMode = () => section.querySelector('input[data-mmx-mode]:checked')?.value || 'onetime';
      const findVariant = (supply) =>
        variants.find((variant) =>
          variant.options.every((value, index) => value === (index === supplyIndex ? supply : selected[index]))
        );

      const update = () => {
        if (supplySelect) selected[supplyIndex] = supplySelect.value;
        const onetime = findVariant(selected[supplyIndex]);
        const subscription = findVariant(subscriptionSupply);
        const variant = currentMode() === 'subscribe' ? subscription : onetime;

        if (!variant) {
          applyVariant(section, activateMedia, { soldOut: true });
        } else {
          applyVariant(section, activateMedia, {
            id: String(variant.id),
            soldOut: !variant.available,
            price: variant.price,
            subPrice: variant.subPrice,
            mediaId: variant.mediaId,
          });
        }

        // applyVariant fills both cards from one variant; each card shows its own supply's price.
        if (subPriceEl && subscription) subPriceEl.textContent = subscription.subPrice;
        if (oneTimePriceEl && onetime) oneTimePriceEl.textContent = onetime.price;
      };

      flavorInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          flavorInputs.forEach((item) => {
            item.closest('.mmx-product-main__variant-pill')?.classList.toggle('is-active', item.checked);
          });
          selected[flavorIndex] = input.value;
          update();
        });
      });

      section.querySelectorAll('input[data-mmx-mode]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          // Switching to Subscribe & Save resets the one-time supply dropdown to its first option.
          if (input.value === 'subscribe' && supplySelect) supplySelect.selectedIndex = 0;
          update();
        });
      });

      // Picking a supply means buying one-time; the mode change listener then updates the variant.
      supplySelect?.addEventListener('change', () => {
        if (onetimeInput && !onetimeInput.checked) {
          onetimeInput.checked = true;
          onetimeInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          update();
        }
      });

      // The one-time card is a <div> around its label, so clicks on its padding select it too.
      const onetimePlan = section.querySelector('div[data-mmx-onetime-plan]');
      onetimePlan?.addEventListener('click', (event) => {
        if (event.target.closest('label, select') || !onetimeInput || onetimeInput.checked) return;
        onetimeInput.checked = true;
        onetimeInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    const bindUpsell = (section) => {
      const sectionId = section.dataset.sectionId || 'mmx-product-main';

      section.querySelectorAll('[data-upsell-variant-id]').forEach((button) => {
        button.addEventListener('click', async () => {
          const variantId = button.dataset.upsellVariantId;
          const parsed = Number.parseInt(button.dataset.upsellQuantity || '', 10);
          const quantity = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
          if (!variantId || button.disabled) return;

          button.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(variantId), quantity }),
            });
            if (!response.ok) throw new Error('Upsell add failed');
            emitCartUpdate(sectionId, await response.json());
          } catch (_error) {
          } finally {
            setTimeout(() => {
              button.disabled = false;
            }, 400);
          }
        });
      });
    };

    const bindAccordions = (section) => {
      const accordions = section.querySelectorAll('.mmx-product-main__accordion');

      const setOpen = (accordion, open, immediate = false) => {
        const trigger = accordion.querySelector('[data-mmx-accordion-trigger]');
        const panel = accordion.querySelector('[data-mmx-accordion-panel]');
        if (!trigger || !panel) return;

        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        accordion.classList.toggle('is-open', open);

        if (immediate) {
          panel.style.transition = 'none';
          panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
          panel.offsetHeight;
          panel.style.transition = '';
          return;
        }

        panel.style.maxHeight = `${panel.scrollHeight}px`;
        if (!open) requestAnimationFrame(() => (panel.style.maxHeight = '0px'));
      };

      accordions.forEach((accordion) => {
        const trigger = accordion.querySelector('[data-mmx-accordion-trigger]');
        if (!trigger) return;
        setOpen(accordion, accordion.classList.contains('is-open'), true);
        trigger.addEventListener('click', () => setOpen(accordion, !accordion.classList.contains('is-open')));
      });

      window.addEventListener('resize', () => {
        accordions.forEach((accordion) => {
          if (!accordion.classList.contains('is-open')) return;
          const panel = accordion.querySelector('[data-mmx-accordion-panel]');
          if (panel) panel.style.maxHeight = `${panel.scrollHeight}px`;
        });
      });
    };

    const initSection = (section) => {
      if (section.dataset.mmxInit === 'true') return;
      section.dataset.mmxInit = 'true';
      const activateMedia = bindGallery(section);
      bindVariants(section, activateMedia);
      bindMerchVariants(section, activateMedia);
      bindFrequency(section);
      bindSplitVariants(section, activateMedia);
      bindUpsell(section);
      bindAccordions(section);
    };

    const initAll = () => document.querySelectorAll('.mmx-product-main[data-section-id]').forEach(initSection);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
